import NavMenu from './NavMenu'
import './NavMenu.scss'

export { default as NavMenuMobile } from './NavMenuMobile'
export default NavMenu